<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
    <path
      d="M17.0983 3C18.4509 3 19.7481 3.53731 20.7046 4.49375L31.727 15.5161H31.7269C33.4244 17.2135 33.4243 19.9656 31.727 21.663L21.663 31.727C19.9656 33.4243 17.2135 33.4244 15.5161 31.7269L4.49375 20.7046C3.53731 19.7481 3 18.4509 3 17.0983V7.37999C3 4.96098 4.96098 3 7.37999 3H17.0983ZM5.99997 17.0983C5.99997 17.6553 6.22125 18.1894 6.61507 18.5832L17.6374 29.6056L17.6375 29.6057C18.1632 30.1314 19.0158 30.1315 19.5417 29.6056L29.6056 19.5417C30.1315 19.0158 30.1314 18.1632 29.6057 17.6375L29.6056 17.6374L18.5832 6.61507C18.1894 6.22125 17.6553 5.99997 17.0983 5.99997H7.37999C6.61783 5.99997 5.99997 6.61783 5.99997 7.37999V17.0983Z"
      fill="url(#paint0_linear_139_4838)"
    />
    <path
      d="M9.08359 9.08408C9.86561 8.30205 11.1335 8.30205 11.9155 9.08408L11.9397 9.1082C12.7217 9.89023 12.7217 11.1581 11.9397 11.9402C11.1577 12.7222 9.88974 12.7222 9.10771 11.9402L9.08359 11.916C8.30156 11.134 8.30156 9.8661 9.08359 9.08408Z"
      fill="url(#paint1_linear_139_4838)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_139_4838"
        x1="15.8864"
        y1="-5.45455"
        x2="41.8115"
        y2="1.02674"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4478FF" />
        <stop offset="1" stop-color="#45B2FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_139_4838"
        x1="10.2278"
        y1="7.36208"
        x2="13.7096"
        y2="8.23254"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4478FF" />
        <stop offset="1" stop-color="#45B2FF" />
      </linearGradient>
    </defs>
  </svg>
</template>
